module.exports = __webpack_public_path__ + "static/media/fff_join_mouseOff.a22b932a.png";